import { Grid, makeStyles, Typography, Box, Dialog, DialogContent } from "@material-ui/core";

import { Button } from "../../../../components/base";
import { COLORS } from "../../../../theme/colors";
import balloonAnimation from "../../../../assets/JSON/balloons.json";
import JsonAnimation from "../../../../components/base/JsonAnimation";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: 995,
    },
  },
  container: {
    borderRadius: 6,
    padding: "60px 0px 36px 0px",
    width: 995,
  },
  mainHead: {
    fontSize: 48,
    fontWeight: 800,
    textAlign: "center",
    color: COLORS.darks[0][100],
  },
  heading: {
    fontSize: 30,
    fontWeight: 700,
    textAlign: "center",
    color: COLORS.darks[0][100],
  },
  subhead: {
    fontSize: 18,
    textAlign: "center",
    color: COLORS.darks[0][100],
  },
  btn: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 60,
    marginTop: 20,
  },
}));

export const OnboardedDoneModal = ({ open, onClose }) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.root}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <Grid
          container
          className={classes.container}
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Box>
            <Typography className={classes.mainHead}>That&#39;s a wrap!</Typography>
            <Typography className={classes.heading}>This building is now onboarded</Typography>
          </Box>
          <Box my={4}>
            <JsonAnimation animationData={balloonAnimation} loop={true} height={250} width={300} />
          </Box>
          <Box>
            <Typography className={classes.subhead}>
              Now go stretch up your legs, grab a coffee, or check what’s left to do
            </Typography>
          </Box>
          <Box className={classes.btn}>
            <Button text="TAKE ME THERE" onClick={onClose} />
          </Box>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
